<render-audio
    *ngIf="element?.url"
    [url]="element.url"
    [hasControls]="true"
    [accessibleLabel]="getAccessibleLabel()"
></render-audio>
